export * from './location-back.component';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/location-back.component/index.ts